import Vue from "vue"; 
import * as rules from 'vee-validate/dist/rules'; 
import { ValidationProvider, extend, ValidationObserver, localize, configure  } from 'vee-validate';
 
 
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

// import { messages } from 'vee-validate/dist/locale/en.json';
// Object.keys(rules).forEach(rule => {
//     extend(rule, {
//         ...rules[rule], // copies rule configuration
//         message: messages[rule] // assign message
//     });
// });

configure({
  // this will be used to generate messages.
  defaultMessage: (field, values) => {
    values._field_ = i18n.t(`fields.${field}`);
    return i18n.t(`validations.messages.${values._rule_}`, values);
  }
});


import { required, email, min } from "vee-validate/dist/rules";
extend("required", required);
extend("email", email);
extend("min", min);

import en from '@/lang/validator/en.json';
import la from '@/lang/validator/la.json';
localize({
  en: {
    messages: en.messages,
    names: {
      email: "Email",
      password: "Password"
    } 
  },
  la: {
    messages: la.messages,
    names: {
      username : "Email",
      password: "ລະຫັດຜ່ານ"
    }  
  }
});

let LOCALE = "en"; 
// set goble
Object.defineProperty(Vue.prototype, "vee_locale", {
  get() {
    return LOCALE;
  },
  set(val) {
    LOCALE = val; 
    localize(val);
  }
});

 


 